import { FETCH_DATA_REQUEST, DISPLAY_ERROR_MESSAGE, RESET_MODEL_AND_ERROR_FLAGS, SET_LOADING_FALSE, FETCH_DATE_CONFIG } from './actionTypes';

export const calendarReportsReducer = (state, action) => {
    switch(action.type) {
        case FETCH_DATE_CONFIG : 
            return {
                ...state,
                sessionTimeoutLimit: action.payload.sessionTimeoutLimit,
                idleTimeoutLimit: action.payload.idleTimeoutLimit,
                minDate : action.payload.minDate,
                maxDate : action.payload.maxDate
            }
        case FETCH_DATA_REQUEST : 
            return {
                ...state,
                isError: action.payload.isError,
                showModel: false,
                modelHeaderTitle: "",
                errorMessage: action.payload.errorMessage,
                isLoading: true
            }         
        case DISPLAY_ERROR_MESSAGE : 
            return {
                ...state,
                isError: action.payload.isError,
                errorMessage: action.payload.errorMessage,
                showModel: action.payload.showModel,
                modelHeaderTitle: action.payload.modelHeaderTitle,               
                isLoading: false
            }  
        case RESET_MODEL_AND_ERROR_FLAGS :  
            return {
                ...state,
                isError: false, 
                errorMessage: "", 
                showModel: false,
                modelHeaderTitle: "",
                isLoading: false                                         
            }
        case SET_LOADING_FALSE:
            return {
                ...state,
                isLoading: action.payload.isLoading                            
            } 
        default : 
            return state;   
    }
}
